import React, { useEffect, useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AddIcon from "@mui/icons-material/Add";
import GenratorModel from './AiModels/GenratorModel';
import boys from "../../../../src/Assets/Images/boys.png"
import robot from "../../../../src/Assets/Images/robot.png"

const ImageGenrator = () => {
  const [openGenratorModel, setOpenGenratorModel] = useState(false);
  useEffect(() => {
    console.log(openGenratorModel);
  }, [openGenratorModel]);

  return (
    <div className="px-4 py-6">
    <GenratorModel
      isOpen={openGenratorModel}
      setIsOpen={setOpenGenratorModel} // Pass state and handler as props
    />

    <div className="p-[14px] shadow-cs rounded-lg mb-[20px] bg-white">
      <h1 className="text-[16px] md:text-[18px] cursor-pointer font-medium text-gray-900 mb-2">
        Image Genrator
      </h1>
      <div className="flex items-center text-sm text-gray-500">
        <a href="/" className="hover:text-gray-700">
          Home
        </a>
        <span className="mx-2">
          <ChevronRightIcon />
        </span>
        <span className="text-gray-700">Image Genrator</span>
      </div>
    </div>
    <div className=" flex items-center justify-between flex-wrap gap-[14px] md:gap-[0] mb-[20px]">
      <div className="flex items-center gap-[16px]">
        <button className="pt-[8px] pb-[8px] pl-[16px] pr-[16px] font-medium   rounded-2xl shadow-cs bg-white text-[13px] md:text-[14px] text-[#8125b0]">
          geminiAi: 99157
        </button>
        <button className="pt-[8px] pb-[8px] pl-[16px] pr-[16px] font-medium  rounded-2xl shadow-cs bg-white text-[13px] md:text-[14px] text-[#008000]">
          OpenAi: 76904
        </button>
      </div>
      <button
        onClick={() => setOpenGenratorModel(true)}
        className=" justify-center create-model md:flex items-center second-btn"
      >
        <AddIcon className="icons-crm" />
        Genrate New
      </button>
    </div>
    <div className=" image-genrator flex  items-center gap-[14px]">
      <img className=" w-[100%] md:h-[250px] md:w-[250px] rounded-md cursor-pointer" src={boys}/>
      <img className=" w-[100%] ßmd:h-[250px] md:w-[250px] rounded-md cursor-pointer" src={robot}/>

    </div>
  
  </div>
  )
}

export default ImageGenrator